import { type NavigateFunction } from 'react-router-dom';

export interface ShareContactViewModel {
  onShareSuccess: () => Promise<void>;
  startWaiting: () => Promise<void>;
  cleanup: () => Promise<void>;
  phone: string;
  navigate: NavigateFunction | null;
}

export const ShareContactViewModelToken = Symbol.for('ShareContactViewModel');
